import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import JsonLd from '@/components/feature/JsonLd';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Features from './components/Features';
import FunctionShowcase from './components/FunctionShowcase';
import Testimonials from './components/Testimonials';
import Brands from './components/Brands';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '好联系 - 让每一次联系都更有价值',
  description: '专为职场人与创业者打造的人脉管理平台，帮助您高效整理联系人、智能跟进关系、挖掘潜在商机。',
  url: 'https://haolianxi.com/',
  isPartOf: {
    '@type': 'WebSite',
    name: '好联系',
    url: 'https://haolianxi.com/',
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://haolianxi.com/',
      },
    ],
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="好联系 - 让每一次联系都更有价值 | 职场人脉管理平台"
        description="好联系是专为职场人与创业者打造的人脉管理平台，帮助您高效整理联系人、智能跟进关系、挖掘潜在商机。告别杂乱通讯录，用好联系让每段关系都产生真实价值。"
        keywords="好联系,人脉管理,联系人管理,职场人脉,商务关系管理,智能通讯录,关系维护"
        canonicalUrl="https://haolianxi.com/"
        ogTitle="好联系 - 让每一次联系都更有价值 | 职场人脉管理平台"
        ogDescription="好联系是专为职场人与创业者打造的人脉管理平台，帮助您高效整理联系人、智能跟进关系、挖掘潜在商机。"
        ogUrl="https://haolianxi.com/"
      />
      <JsonLd data={homeJsonLd} />

      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <Hero />
          <Stats />
          <Features />
          <FunctionShowcase />
          <Testimonials />
          <Brands />
          <CTASection />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}